<template>
    <div>
        <Header></Header>
        <div class="eyecatcher">
            <img class="homepage-start-img" src="../assets/wall.jpg" alt="thewall"/>
            <h1 class="homepage-quote"> conquer the
                <TypeEffect></TypeEffect>
            </h1>
            <h2 class="homepage-quote-two">creativity > copy & paste</h2>
        </div>
        <div class="background-top-connection"></div>
    <div class="top-container">
        <div class="animation-area">
            <div class="skills-and-offer">
                <div class="skills-and-offer-header">
                    <h1 class="skills-and-offer-quote">what i can do.</h1>
                </div>

                <div v-observe-visibility="{ callback: isViewableNow, once: false }"
                     :class="{'visible animated fadeInRight': shown, 'invisible': !shown }">

                <div class="item-header">
                    <p>
                        Design what you want.
                    </p>
                </div>
                <div class="skills-and-offer-item">
                    <b-icon class="icon" icon="cloud-fill" style="width: 150px; height: 150px; color: white; float: left; margin-left: 30vw"></b-icon>
                    <div class="skills-and-offer-text">
                        <span>
                              Be different with <br/>
                              innovative design. <br/>
                              That's what I aim for.
                        </span>
                    </div>
                </div>
                </div>
                <div class="skills-and-offer-spacer" style="height: 50px;"></div>

                <div v-observe-visibility="{ callback: isViewableNowTwo, once: false }"
                     :class="{'visible animated fadeInLeft': shownTwo, 'invisible': !shownTwo }">

                <div class="item-header-reverse">
                    <p>
                        Develop what you need.
                    </p>
                </div>
                <div class="skills-and-offer-item">
                    <div class="skills-and-offer-text-reverse">
                        <span>As a web developer  <br/>
                            I focus on websites  <br/>
                            and web shops. <br/>
                        </span>
                    </div>
                    <b-icon class="icon-reverse" icon="display-fill" style="width: 150px; height: 150px; color: white; float: right; margin-right: 30vw"></b-icon>
                </div>
                </div>
                <div style="height: 100px; margin-top: -50px"></div>
                <div class="after-skills-and-offer" style="width: 70vw; margin-left: 15vw; margin-right: 15vw">
                    <p style="font-family: 'Mansalva', cursive; color: #FFD700;">I'm currently available for freelance work.</p>
                </div>
                <div style="height: 100px; margin-top: 10vh">
                    <div style="position: relative; z-index: 10;">
                        <b-card style="background: transparent; box-shadow: none; padding: 0;">
                        <b-button to="/contact" pill variant="warning" style="color: black; font-family: 'Mansalva', cursive;">
                            <b-icon icon="cursor-fill" style="margin-right: 5px"></b-icon>
                            message me</b-button>
                        </b-card>
                    </div>
                </div>
            </div>
            <ul class="box-area">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
            </ul>
            <BasePage></BasePage>
        </div>
    </div>
    </div>
</template>

<script>
    import Header from "@/components/Header";
    import BasePage from "@/components/BasePage";
    import TypeEffect from "@/components/TypeEffect";

    export default {
        name: 'HomePage',
        components: {TypeEffect, BasePage, Header},
        data() {
            return {
                shown: false,
                shownTwo: false
            }
        },
        methods: {
            // eslint-disable-next-line no-unused-vars
            isViewableNow(isVisible, entry) {
                this.shown = isVisible;
            },
            // eslint-disable-next-line no-unused-vars
            isViewableNowTwo(isVisible, entry) {
                this.shownTwo = isVisible;
            }
        },
        mounted () {
            window.scrollTo(0, 0)
        }
    };
</script>

<style>

    .top-container {
        margin-top: -70vh;
        padding: 0;
        width: 100%;
        height: 100vh;
    }

    div.card-body {
        padding: 0!important;
    }

    .eyecatcher {
        width: 100%;
        height: 80vh;
        background: linear-gradient(to left, black, #202020);
        position: relative;
        text-align: center;
    }

    .homepage-quote {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-family: 'Mansalva', cursive;
        font-weight: bold;
        font-size: 100px;
        letter-spacing: 10px;
        width: 100%;
        color: white;
    }

    .homepage-quote-two {
        position: absolute;
        top: 70%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-family: 'Mansalva', cursive;
        font-weight: normal;
        font-size: 50px;
        letter-spacing: 10px;
        width: 100%;
        color: white;
    }

    .homepage-start-img {
        width: 100%;
        height: 90vh;
        position: relative;
    }

    .item-header p {
        color: #FFD700;
        font-family: 'Mansalva', cursive;
        font-size: 30px;
        margin-left: 25vw;
        margin-right: auto;
        margin-bottom: -30px;
    }

    .item-header-reverse p {
        color: #FFD700;
        font-family: 'Mansalva', cursive;
        font-size: 30px;
        margin-right: 25vw;
        margin-left: auto;
        margin-bottom: -30px;
    }

    .skills-and-offer {
        width: 100%;
        height: 100vh;
        background: transparent;
        padding-top: 100px;
        margin-right: auto;
    }

    .skills-and-offer-header {
        width: 100%;
        height: 150px;
    }

    .skills-and-offer-quote {
        font-family: 'Mansalva', cursive;
        font-weight: bold;
        font-size: 70px;
        letter-spacing: 10px;
        width: 100%;
        color: #FFD700;
    }

    .skills-and-offer-item {
        text-align: center;
        color: white;
        height: 150px;
        width: auto;
        background: transparent;
    }

    .skills-and-offer-text {
        height: 150px;
        line-height: 150px;
        width: 100%;
        text-align: center;
        margin-left: -200px;
        font-family: 'Roboto', sans-serif;
        letter-spacing: 0.5px;
    }

    .skills-and-offer-text-reverse {
        height: 150px;
        line-height: 150px;
        width: 70vw;
        text-align: center;
        margin-left: 2vw;
        float: left;
        position: absolute;
        font-family: 'Roboto', sans-serif;
        letter-spacing: 0.5px;
    }

    span {
        display: inline-block;
        vertical-align: middle;
        line-height: normal;
    }

    .after-skills-and-offer p {
        font-size: 40px;
    }

    .background-top-connection {
        width: 100%;
        height: 1vh;
        background: black;
        margin-top: 10vh;
    }

    .banner-text ul {
        height: 50px;
        float: right;
    }

    .banner-text ul li {
        display: inline-block;
        padding: 40px 15px;
        text-transform: uppercase;
        color: #fff;
        font-size: 20px;
    }

    .banner-text h2 {
        text-align: center;
        color: #ffffff;
        font-size: 50px;
        margin-top: 20%;
    }

    .animation-area {
        background: linear-gradient(to left, black, #202020);
        width: 100%;
        height: 100vh;
        min-height: 650px;
        margin-top: 70vh;
    }

    .box-area {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        margin-top: 70vh;
        padding: 0;
    }

    .box-area ul {
        padding: 0;
    }

    .box-area li {
        position: absolute;
        display: block;
        list-style: none;
        width: 25px;
        height: 25px;
        background: rgba(255, 255, 255, 0.2) repeat;
        animation: animate 20s linear infinite;
        bottom: -150px;
        border-radius: 80px;
    }

    .box-area li:nth-child(1) {
        left: 86%;
        width: 80px;
        height: 80px;
        animation-delay: 0s;
    }

    .box-area li:nth-child(2) {
        left: 12%;
        width: 30px;
        height: 30px;
        animation-delay: 1.5s;
        animation-duration: 10s;
    }

    .box-area li:nth-child(3) {
        left: 70%;
        width: 100px;
        height: 100px;
        animation-delay: 5.5s;
    }

    .box-area li:nth-child(4) {
        left: 42%;
        width: 150px;
        height: 150px;
        animation-delay: 0s;
        animation-duration: 15s;
    }

    .box-area li:nth-child(5) {
        left: 65%;
        width: 40px;
        height: 40px;
        animation-delay: 0s;
    }

    .box-area li:nth-child(6) {
        left: 15%;
        width: 110px;
        height: 110px;
        animation-delay: 3.5s;
    }

    @keyframes animate {
        0%{
            transform: translateY(0) rotate(0deg);
            opacity: 1;
        }

        100%{
            transform: translateY(-800px) rotate(360deg);
            opacity: 0;
        }
    }

    @media only screen and (min-width: 600px) and (max-width: 759px) {
        .homepage-quote {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-family: 'Mansalva', cursive;
            font-weight: bold;
            font-size: 60px;
            letter-spacing: 5px;
            width: 100%;
        }

        .homepage-quote-two {
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-family: 'Mansalva', cursive;
            font-weight: normal;
            font-size: 30px;
            letter-spacing: 10px;
            width: 100%;
            color: white;
        }

        .icon {
            width: 100px!important;
            height: 100px!important;
            margin-left: 20vw!important;
        }

        .icon-reverse {
            width: 100px!important;
            height: 100px!important;
            margin-right: 20vw!important;
        }

        .skills-and-offer-item {
            height: 100px;
        }

        .skills-and-offer-text {
            height: 100px;
            line-height: 100px;
            margin-left: -70px;
        }

        .skills-and-offer-text-reverse {
            height: 100px;
            line-height: 100px;
            margin-right: 70px;
        }

        .item-header p {
            font-size: 25px;
            margin-left: 25vw;
            margin-right: auto;
            margin-bottom: -20px;
        }

        .item-header-reverse p {
            font-size: 25px;
            margin-right: 25vw;
            margin-left: auto;
            margin-bottom: -20px;
        }

        .after-skills-and-offer p {
            font-size: 30px;
        }
    }

    @media only screen and (min-width: 760px) and (max-width: 1000px) {
        .homepage-quote {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-family: 'Mansalva', cursive;
            font-weight: bold;
            font-size: 80px;
            letter-spacing: 5px;
            width: 100%;
        }

        .homepage-quote-two {
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-family: 'Mansalva', cursive;
            font-weight: normal;
            font-size: 45px;
            letter-spacing: 10px;
            width: 100%;
            color: white;
        }

        .icon {
            width: 100px!important;
            height: 100px!important;
            margin-left: 20vw!important;
        }

        .icon-reverse {
            width: 100px!important;
            height: 100px!important;
            margin-right: 20vw!important;
        }

        .skills-and-offer-item {
            height: 100px;
        }

        .skills-and-offer-text {
            height: 100px;
            line-height: 100px;
            margin-left: -70px;
        }

        .skills-and-offer-text-reverse {
            height: 100px;
            line-height: 100px;
            margin-right: 70px;
        }

        .item-header p {
            font-size: 25px;
            margin-left: 25vw;
            margin-right: auto;
            margin-bottom: -20px;
        }

        .item-header-reverse p {
            font-size: 25px;
            margin-right: 25vw;
            margin-left: auto;
            margin-bottom: -20px;
        }

        .after-skills-and-offer p {
            font-size: 30px;
        }

        .animation-area {
            height: 140vh;
        }
    }

    @media only screen and (min-width: 300px) and (max-width: 599px) {
        .homepage-quote {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-family: 'Mansalva', cursive;
            font-weight: bold;
            font-size: 41px;
            letter-spacing: 5px;
            width: 100%;
        }

        .homepage-quote-two {
            position: absolute;
            top: 65%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-family: 'Mansalva', cursive;
            font-weight: normal;
            font-size: 23px;
            letter-spacing: 5px;
            width: 100%;
            color: white;
            margin-top: 15px;
        }

        .icon {
            width: 50px!important;
            height: 50px!important;
            margin-left: 15vw!important;
        }

        .icon-reverse {
            width: 50px!important;
            height: 50px!important;
            margin-right: 15vw!important;
        }

        .skills-and-offer-quote {
            font-size: 30px;
            margin-top: -20px;
        }

        .skills-and-offer-header {
            height: 70px;
        }

        .skills-and-offer-item {
            height: 50px;
        }

        .skills-and-offer-text {
            height: 50px;
            line-height: 50px;
            font-size: 13px;
            margin-left: 0;
        }

        .skills-and-offer-text-reverse {
            height: 50px;
            line-height: 50px;
            font-size: 13px;
            margin-right: 0;
        }

        .item-header p {
            font-size: 20px;
            margin-left: 25vw;
            margin-right: auto;
            margin-bottom: 0;
        }

        .item-header-reverse p {
            font-size: 20px;
            margin-right: 25vw;
            margin-left: auto;
            margin-bottom: 0;
        }

        .after-skills-and-offer p {
            font-size: 20px;
        }

        .box-area {
            height: 140vh;
        }

        .animation-area {
            height: 140vh;
        }
    }

    @media only screen and (max-width: 374px) {
        .homepage-quote {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-family: "Mansalva", cursive;
            font-weight: bold;
            font-size: 33px;
            letter-spacing: 5px;
            width: 100%;
        }

        .homepage-quote-two {
            position: absolute;
            top: 65%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-family: "Mansalva", cursive;
            font-weight: normal;
            font-size: 20px;
            letter-spacing: 3px;
            width: 100%;
            color: white;
        }

        .icon {
            width: 50px!important;
            height: 50px!important;
            margin-left: 15vw!important;
        }

        .icon-reverse {
            width: 50px!important;
            height: 50px!important;
            margin-right: 15vw!important;
        }

        .skills-and-offer-quote {
            font-size: 30px;
            margin-top: -20px;
        }

        .skills-and-offer-header {
            height: 70px;
        }

        .skills-and-offer-item {
            height: 50px;
        }

        .skills-and-offer-text {
            height: 50px;
            line-height: 50px;
            font-size: 13px;
            margin-left: 0;
        }

        .skills-and-offer-text-reverse {
            height: 50px;
            line-height: 50px;
            font-size: 13px;
            margin-right: 0;
        }

        .item-header p {
            font-size: 20px;
            margin-left: 25vw;
            margin-right: auto;
            margin-bottom: 0;
        }

        .item-header-reverse p {
            font-size: 20px;
            margin-right: 25vw;
            margin-left: auto;
            margin-bottom: 0;
        }

        .after-skills-and-offer p {
            font-size: 20px;
        }

        .box-area {
            height: 140vh;
        }
    }

    @media only screen and (orientation: landscape) and (min-width: 500px) and (max-width: 829px) {
        .animation-area {
            min-height: 950px;
            height: 120vh;
        }

        .box-area {
            margin-top: 145vh;
            height: 180vh;
        }

        .homepage-quote-two {
            margin-top: 60px;
        }
    }

    @media only screen and (orientation: landscape) and (min-width: 830px) and (max-width: 1050px) {

        .animation-area {
            height: 130vh;
        }

        .box-area {
            margin-top: 50vh;
            height: 180vh;
        }

        .homepage-quote-two {
            margin-top: 50px;
        }
    }

    @media only screen and (min-width: 1001px) and (max-width: 1300px){

        .animation-area {
            height: 130vh;
        }
        .box-area {
            margin-top: 102vh;
            height: 70vh;
        }
    }

    @media only screen and (min-width: 1301px) {

        .animation-area {
            height: 130vh;
        }
        .box-area {
            margin-top: 102vh;
            height: 100vh;
        }
    }

</style>
